import { Box, useTheme } from '@chakra-ui/react';

const ProgressBar = ({ percentile, completed, children, progressBarColor }) => {
  const theme = useTheme();

  return (
    <Box
      height='4px'
      marginTop='0.5em'
      width='100%'
      backgroundColor={theme.colors.bgGrey}
      borderRadius='50px'
    >
      <Box
        height='100%'
        position='relative'
        width={`${completed}%`}
        backgroundColor={
          progressBarColor ||
          (percentile > 0.5
            ? theme.colors.graphicGreen
            : theme.colors.graphicRed)
        }
        borderRadius='inherit'
        textAlign='right'
      >
        {children}
      </Box>
    </Box>
  );
};

export default ProgressBar;
